// extracted by mini-css-extract-plugin
module.exports = {"dot":"Dot_dot__0hYrc","blackSmallDot":"Dot_blackSmallDot__58c_2"};